export class ProcessoSeletivo {
  TipoProcesso = [];
  Processos = [];
}



// WEBPACK FOOTER //
// ./src/app/_shared/processo/processo-seletivo.ts